export default "<p>unsubscribe works!</p>\n"